import type { StatusVariant } from '@factorialco/f0-react'
import i18n from 'modules/core/lib/i18n'

export type RequestStatus = 'active' | 'pending' | 'finished'

export const REQUEST_STATUSES: Record<RequestStatus, RequestStatus> = {
  active: 'active',
  pending: 'pending',
  finished: 'finished',
}

export const REQUEST_STATUS_COLORS: Record<RequestStatus, StatusVariant> = {
  active: 'positive',
  pending: 'warning',
  finished: 'neutral',
}

export function getRequestStatusLabel(status: RequestStatus): string {
  return {
    active: i18n.t('planning.periods_page.request_status.active'),
    pending: i18n.t('planning.periods_page.request_status.pending'),
    finished: i18n.t('planning.periods_page.request_status.finished'),
  }[status]
}
